export default __webpack_public_path__ + "static/media/membre_kamille.094ca1ec.JPG";